<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">
    
        <h1>
          <p class="text-center font-weight-bold">
            Cadastrar Título
          </p>
          <!-- {{recepcionista}} -->
        </h1>
    

        <v-form ref="form" v-model="valid" class="mx-4">
          <v-text-field v-model="titulo" label="Descrição do Título" :rules="tituloRules" required />

          <v-checkbox v-model="checkbox" label="Você concorda?" :rules="[(v) => !!v || 'Você deve concordar para cadastrar']" required />

          <v-alert :value="erroCadastrar" color="error" icon="warning" outlined>
            Erro ao cadastrar título !!
          </v-alert>

          <v-alert :value="sucessCadastrar" color="success" icon="check_circle" outlined>
            Título cadastrado com sucesso !!
          </v-alert>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn dark rounded :class="{ red: !valid, green: valid }" @click="submit">
            cadastrar
          </v-btn>
          <v-btn text @click="" @click="$router.go(-1)">
            <v-icon left>
              keyboard_backspace
            </v-icon>
            voltar
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'

export default {
  name: 'CadastrarAtendenteUnidade',
  components: {
    // HelloWorld
  },
  data() {
    return {
      show1: false,
      valid: false,
      titulo: "",
      idLocalEscolhido: undefined,
      isEditing: true,
      tipo: 7,
      erroCadastrar: false,
      sucessCadastrar: false,
      senha: '',
      respostaServidor: '',
      username: '',
      nome: '',
      tituloRules: [
        (v) => !!v || 'Título obrigatório',
      ],

      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false

    }
  },
  created() {
    console.log('created...')
  },
  mounted() {
    console.log('em mounted lista unid...')
    // console.log(this.user);
    this.user = this.$store.getters.usuario
  },
  methods: {

    clear() {
      this.$refs.form.reset()
      this.erroCadastrar = false
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.erroCadastrar = false,
          this.sucessCadastrar = false
        administradorDesenvolvimentoService.administradorDesenvolvimento
          .cadastrarTituloHelp(this.titulo)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == false) {
              this.erroCadastrar = true
            }
            if (rsp.data == true) {
              this.sucessCadastrar = true
              this.clear()
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

  }
}
</script>
